import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import Chip from "components/common/Chip";
import Typography from "components/common/Typography";
import { uniqueId } from "lodash";
import { useContext } from "react";
import { tokens } from "styles/Tokens";
import { nestedTernaryCheckerCond2 } from "utils/CommonChecker";
import "./Mcqlist.scss";
interface Props {
  list: any;
  handleChange: (...args: any) => void;
  currQues?: any;
  selectedList: any;
  sx?: {};
  role?: boolean;
  filterData?: boolean;
}
export default function Mcqlist(props: Props) {
  const { list, handleChange, currQues, selectedList, role = false, filterData = false, sx } = props;

  const filterMcq = filterData || currQues?.questionType === "FILTER_MCQ";
  const Mcq = currQues?.questionType === "MCQ";
  const { isMobileScreen } = useContext(ThemeContext);
  return (
    <>
      {list
        ?.filter((val: any) => !selectedList?.includes(role ? val?.roleName : val?.answerOption))
        ?.map((option: any, index: number) => {
          return (
            <Grid
              item
              xs={!isMobileScreen && Mcq ? 6 : 12}
              style={{ marginBottom: "8px" }}
              key={nestedTernaryCheckerCond2(role, filterMcq, option?.id, option?.userRoleId, option?.answerOption)}
            >
              <div className="options-container">
                <div className="chip-wrapper">
                  <div className="options-chips">
                    {option.tags?.map((tag: string) => {
                      return (
                        <Chip
                          key={uniqueId("TAG_")}
                          size="small"
                          backgroundColor={tokens.Primary.Primary200}
                          label={tag}
                          sx={{ padding: "0px 8px" }}
                        />
                      );
                    })}
                  </div>
                </div>
                <FormControlLabel
                  sx={{
                    border: `1px solid ${tokens.Border.General.Tertiary}`,
                    borderRadius: "8px",
                    padding: "8px 12px",
                    margin: "0px",
                    width: "100%",
                    ...sx
                  }}
                  className="wizard-checkbox"
                  style={{ backgroundColor: tokens.Background.General.Secondary }}
                  value={role ? option?.roleName : option?.answerOption}
                  control={
                    <Checkbox
                      onChange={handleChange}
                      checked={false}
                      name={role ? option?.roleName : option?.answerOption}
                    />
                  }
                  label={
                    <>
                      <Typography variant="body2" showBold>
                        {" "}
                        {role ? option.roleName : option?.answerOption}
                      </Typography>
                      {filterMcq && (
                        <Chip
                          label={option.filterCategory}
                          color={tokens.Text.General.Secondary}
                          backgroundColor="transparent"
                          borderColor={tokens.Border.General.Tertiary}
                        />
                      )}
                    </>
                  }
                  labelPlacement="start"
                />
              </div>
            </Grid>
          );
        })}{" "}
    </>
  );
}
